import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@/shared/components/Button/Button';
import { Text } from '@/shared/components/Text/Text';
import { TextSize, TextTag, TextWeight, Theme } from '@/shared/components/Text/Text.types';
import { clientConfig } from '@/config/client';

import { useCleanError, useCurrentError } from '../../../../error-boundary-context/context';
import { ErrorOverlay } from '../../error/error-overlay/component';
import { ErrorOverlayBody } from '../../error/error-overlay-body/component';
import styles from '../styles.module.css';

const { brandName } = clientConfig;

export const TooManyConcurrentStreamsError: React.FC = () => {
    const cleanError = useCleanError();
    const { onErrorClose } = useCurrentError() as { onErrorClose?: () => void };

    const handleClose = React.useCallback(() => {
        cleanError();
        onErrorClose?.();
    }, [cleanError, onErrorClose]);

    return (
        <ErrorOverlay>
            <ErrorOverlayBody>
                <div className={styles.mainText}>
                    <Text
                        weight={TextWeight.Bold}
                        size={TextSize.Superhead}
                        tag={TextTag.H1}
                        theme={Theme.Dark}
                    >
                        <FormattedMessage
                            id="features.player.68e5f58c85b10a04a38f762c69c668a3"
                            defaultMessage="Someone is already using this account{br}to watch {brandName}"
                            description="Текст заголовка на экране ошибки ограничения одновременных просмотров"
                            values={{ br: <br />, brandName }}
                        />
                    </Text>
                    <Text
                        weight={TextWeight.Regular}
                        size={TextSize.Subtitle}
                        theme={Theme.Grey}
                        className={styles.subtitle}
                    >
                        <FormattedMessage
                            id="features.player.deb7037ee53dcb757de4638889a11d14"
                            defaultMessage="To start watching, just close the app{br}on the other device"
                            description="Текст подзаголовка на экране ошибки ограничения одновременных просмотров"
                            values={{ br: <br /> }}
                        />
                    </Text>
                </div>

                <span className={styles.buttonRow}>
                    <span className={styles.button}>
                        <Button variant="accent" onClick={handleClose} size={44}>
                            <FormattedMessage
                                id="components.RefreshButton.78e981599281c16fe016b55b136edf5f"
                                defaultMessage="Got it"
                                description="Текст кнопки на экране ошибки ограничения одновременных просмотров"
                            />
                        </Button>
                    </span>
                </span>
            </ErrorOverlayBody>
        </ErrorOverlay>
    );
};
